import React from 'react';
import {Box} from "@material-ui/core";
import gridImage1 from '../../../../resources/images/rail-grid-image.jpg';
import Slideshow from "../../../Common/Slideshow/Slideshow";
import useStyles from "./Rail&FlyGridImagesStyles";

const RailFlyGridImages = () => {
    const classes = useStyles();

    return (
        <Box display={'flex'} flexDirection={'column'} borderRadius={'6px'}>
            <Slideshow
                className={classes.img1}
                defaultImage={gridImage1}
            />
        </Box>
    );
};

export default RailFlyGridImages;
